export default __webpack_public_path__ + "static/media/ADOS.705bd395.png";